var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('h1',{staticClass:"nutriyou-h1"},[_vm._v(_vm._s(_vm.$t("pageTitle")))]),_c('vue-pivottable-ui',{attrs:{"data":_vm.items,"rows":['Nome Cliente'],"cols":['Anno Ordine']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }